"use strict";
var $dyn;
(function ($dyn) {
    /**
     * Calls the provided function when the client has completed any pending operations.
     * @description User interaction will be blocked until just before the function is called.
     */
    function callWhenNotBusy(callback) {
        if ($dyn.value($dyn.clientBusy)) {
            $dyn.shell.blockUserInteractionNoWait("callWhenNotBusy");
            $dyn.observe($dyn.clientBusy, function (isBusy) {
                if (!isBusy) {
                    $dyn.shell.unBlockUserInteraction();
                    $dyn.callFunction(callback);
                    return false;
                }
            });
        }
        else {
            $dyn.callFunction(callback);
        }
    }
    $dyn.callWhenNotBusy = callWhenNotBusy;
    var deferred;
    (function (deferred_1) {
        /**
         * Created a deferred object that waits for the observied object to have a value. Once the object has a value, the deferred object is resolved.
         * @description Note that if the value is an object then the deferred is immediately resolved.
         * @example
         *   $.when($dyn.deferred.onHasValue($dyn.user)).done(function (user) {
         *       // Wait for when the user is available then do something with the user
         *   });
         *
         * @param observing The observed object/function.
         */
        function onTrue(observing) {
            // tslint:disable-next-line:no-shadowed-variable
            var deferred = $.Deferred();
            var result;
            var subscription;
            if ($dyn.isObservable(observing)) {
                result = observing();
                if (result) {
                    deferred.resolve(result);
                }
                else {
                    subscription = observing.valueChanged.subscribe(function () {
                        result = observing();
                        if (result) {
                            observing.valueChanged.unsubscribe(subscription);
                            deferred.resolve(result);
                        }
                    });
                }
            }
            else if (typeof observing === "function") {
                var observable_1 = $dyn.computed(observing);
                result = observable_1();
                if (result) {
                    observable_1.valueChanged.clearAllDependencies();
                    deferred.resolve(result);
                }
                else {
                    subscription = observable_1.valueChanged.subscribe(function () {
                        result = observable_1();
                        if (result) {
                            observable_1.valueChanged.unsubscribe(subscription);
                            observable_1.valueChanged.clearAllDependencies();
                            deferred.resolve(result);
                        }
                    });
                }
            }
            else {
                if (observing) {
                    deferred.resolve(observing);
                }
            }
            return deferred;
        }
        deferred_1.onTrue = onTrue;
        deferred_1.onHasValue = onTrue;
    })(deferred = $dyn.deferred || ($dyn.deferred = {}));
    /**
     * Invoke a callback asynchronously, with an optional timeout.
     * @description Invoke a callback asynchronously, with an optional timeout. This is
     * functionally identical to window.setTimeout, except that it increments
     * and internal counter when the callback is set and decrements it when the
     * callback is completed or canceled. This is the preferred way to perform
     * most asynchronous actions, especially those that affect data or control
     * state.
     *
     * @param callback The callback to execute.
     * @param timeout The timeout in MS before executing the callback.
     * @param message The message to used by logging for the asynchronous call.
     * @param thisArg The this context to execute the callback with.
     * @returns A plain object with a 'cancel' method.
     */
    function async(callback, timeout, message, thisArg) {
        // Completely disallow unsafe string arguments
        if (typeof callback !== "function") {
            throw new TypeError("First argument to $dyn.async must be a function");
        }
        var timerId = 0;
        // isValid tracks whether the callback has already completed or been
        // canceled. It allows us to make cancel() impotent and ensure we never
        // decrement more than once.
        var isValid = true;
        $dyn.async.pending.increment("$dyn.async id " + timerId + ", message: '" + message + "' timeout (ms) " + (timeout === undefined ? 0 : timeout));
        // tslint:disable-next-line:only-arrow-functions
        var callbackWrapper = function () {
            try {
                callback.call(thisArg, arguments);
            }
            finally {
                $dyn.async.pending.decrement("$dyn.async id " + timerId + ", message: '" + message + "' complete");
                isValid = false;
            }
        };
        if (!$dyn.async.debugForceSync) {
            timerId = window.setTimeout(callbackWrapper, timeout);
        }
        else {
            callbackWrapper();
        }
        return {
            cancel: function () {
                if (isValid) {
                    window.clearTimeout(timerId);
                    isValid = false;
                    $dyn.async.pending.decrement("$dyn.async " + timerId + ", message:'" + message + "' cancel");
                }
            },
        };
    }
    $dyn.async = async;
    (function (async) {
        async.nonThrottled = 0;
        async.throttledCommandProcessing = false;
        async.pending = Object.assign($dyn.observable(0), {
            decrement: function (message) {
                var value = $dyn.peek($dyn.async.pending);
                value--;
                $dyn.log.async && $dyn.log.async("$dyn.async.pending decrement, count = %d : %s", value, message);
                if (value < 0) {
                    value = 0;
                    $dyn.logError("$dyn.async.pending decremented to <0 ");
                }
                // Hide the "loading" element if we just finished loading
                if (value === 0) {
                    // let the stack unwind then fire
                    window.setTimeout(function () {
                        if ($dyn.value($dyn.async.pending) === 0) {
                            $dyn.clientBusy(false);
                        }
                    });
                }
                // Unset the current scope when we modify this observable. We never want to
                // create dependencies on $dyn.async.pending except through explicit calls
                // to $dyn.observe or similar
                var scope = $dyn.computed.scope;
                $dyn.computed.scope = undefined;
                $dyn.async.pending(value);
                $dyn.computed.scope = scope;
            },
            increment: function (message) {
                var value = $dyn.peek($dyn.async.pending);
                value++;
                $dyn.log.async && $dyn.log.async("$dyn.async.pending increment, count = %d : %s", value, message);
                // Unset the current scope when we modify these observables. We never want to
                // create dependencies on $dyn.async.pending except through explicit calls
                // to $dyn.observe or similar
                var scope = $dyn.computed.scope;
                $dyn.computed.scope = undefined;
                $dyn.async.pending(value);
                if (value === 1) {
                    $dyn.clientBusy(true);
                }
                $dyn.computed.scope = scope;
            },
        });
        /**
         * Returns true if the client is busy processing interactions.
         */
        function IsClientProcessing() {
            return ($dyn.clientBusy() && ($dyn.async.nonThrottled > 0 ||
                $dyn.async.throttledCommandProcessing ||
                ($dyn.util.isFlightEnabled($dyn.reactGrid.featureName) && !$dyn.value($dyn.util.controlLibraryResourcesLoaded))));
        }
        async.IsClientProcessing = IsClientProcessing;
    })(async = $dyn.async || ($dyn.async = {}));
    // Various universal hooks into $dyn.async.pending
    $(document).on("ajaxStart", function () {
        $dyn.async.pending.increment("ajaxStart");
    });
    $(document).on("ajaxStop", function () {
        $dyn.async.pending.decrement("ajaxStop");
    });
})($dyn || ($dyn = {}));

//# sourceMappingURL=Async.js.map
